(function($){
    $('.popup__image').magnificPopup({
        delegate: 'a',
        type:     'image',

        image: {
            titleSrc: 'title'
        }
    });

    $('.popup__gallery').magnificPopup({
        delegate: 'a',
        type:     'image',

        gallery: {
            enabled: true
        },

        image: {
            titleSrc: 'title'
        }
    });

    $('.popup__ajax').magnificPopup({
        type: 'iframe'
    });


    if ($('.popup__video').length) {
        $('.popup__video').magnificPopup({
            type:            'iframe',
            mainClass:       'mfp-fade',
            removalDelay:    160,
            preloader:       false,
            fixedContentPos: false
        });
    }
        
}(jQuery));
